module.exports = __webpack_public_path__ + "img/ycsj.220955b9.svg";